import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { PershingCoreModule } from '@pershing/pershing-core';
import {
  PershingCommonModule,
  PershingModalService,
} from '@pershing/pershing-common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyOptionModule as MatOptionModule } from '@angular/material/legacy-core';
import { MatLegacyProgressBarModule as MatProgressBarModule } from '@angular/material/legacy-progress-bar';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDividerModule } from '@angular/material/divider';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';
import { QuoteToggleService } from './services/quotetoggle.service';
import { QuoteToggleComponent } from './components/quotetoggle/quotetoggle.component';
import { QuoteTypeDropdownComponent } from './components/quote-type-dropdown/quote-type-dropdown.component';
import { AsOfDateComponent } from './components/as-of-date/as-of-date.component';
import { RefreshButtonComponent } from './components/refresh-button/refresh-button.component';

export const COMPONENTS: any[] = [
  QuoteToggleComponent,
  QuoteTypeDropdownComponent,
  AsOfDateComponent,
  RefreshButtonComponent,
];

@NgModule({
  imports: [
    PershingCoreModule,
    PershingCommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    FormsModule,
    MatIconModule,
    MatDialogModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatProgressBarModule,
    MatCardModule,
    MatExpansionModule,
    MatDividerModule,
    MatMenuModule,
    MatInputModule,
    MatButtonModule,
    MatGridListModule,
    MatButtonToggleModule,
    MatTableModule,
    MatSlideToggleModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
  providers: [QuoteToggleService, PershingModalService, DatePipe],
})
export class QuoteToggleModule {}
